import { useAuth } from "@/hooks/useAuth";
import {
  LogOut,
  User,
  LogIn,
  X,
} from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/common/LanguageSwitcher";

interface NavbarProps {
  hideSidebarButtons?: boolean;
  hideLoginLink?: boolean;
}

export default function Navbar({ hideLoginLink = false }: NavbarProps) {
  const { user, logout } = useAuth();
  const { t } = useTranslation(["auth", "common"]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
 <nav aria-label={t("common:navigation.siteNav")} className="bg-white border-b border-secondary-200 sticky top-0 z-50">
 <div className="page-container lg:px-8">
 <div className="flex justify-between h-16">
  <div className="flex items-center space-x-4">
            <Link
              to="/"
 className="text-lg sm:text-xl font-semibold text-secondary-900"
            >
 <span className="hidden sm:inline">Race Manager</span>
 <span className="sm:hidden">RM</span>
            </Link>
          </div>

 <div className="flex items-center space-x-2">
            {/* Language Switcher */}
            <LanguageSwitcher />

            {user ? (
              <>
                {/* Desktop user menu */}
 <div className="hidden sm:flex items-center space-x-4">
                  <Link
                    to="/my-page"
 className="flex items-center space-x-2 hover:text-primary-600"
                  >
 <User className="h-5 w-5 text-secondary-500" />
 <span className="text-sm text-secondary-700 truncate max-w-32 hover:text-primary-600">
                      {user.email}
                    </span>
                  </Link>

                  <button
                    onClick={logout}
 className="flex items-center space-x-1 text-secondary-500 hover:text-secondary-700 px-3 py-2 rounded-lg text-sm font-medium"
                  >
 <LogOut className="h-4 w-4" />
                    <span>{t("auth:logout")}</span>
                  </button>
                </div>

                {/* Mobile user menu button */}
                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
 className="sm:hidden p-2 rounded-lg text-secondary-400 hover:text-secondary-500 hover:bg-secondary-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
                >
 <span className="sr-only">{t("common:navigation.openUserMenu")}</span>
                  {mobileMenuOpen ? (
 <X className="h-6 w-6" />
                  ) : (
 <User className="h-6 w-6" />
                  )}
                </button>
              </>
            ) : (
              !hideLoginLink && (
                <Link
                  to="/login"
 className="flex items-center space-x-1 text-secondary-500 hover:text-secondary-700 px-3 py-2 rounded-lg text-sm font-medium"
                >
 <LogIn className="h-4 w-4" />
 <span className="hidden sm:inline">{t("auth:login")}</span>
                </Link>
              )
            )}
          </div>
        </div>

        {/* Mobile user menu */}
        {user && mobileMenuOpen && (
 <div className="sm:hidden border-t border-secondary-200 py-2">
            <Link
              to="/my-page"
              onClick={() => setMobileMenuOpen(false)}
 className="flex items-center px-4 py-2 hover:bg-secondary-50"
            >
 <User className="h-5 w-5 text-secondary-500 mr-2" />
 <span className="text-sm text-secondary-700 truncate hover:text-primary-600">
                {user.email}
              </span>
            </Link>

            <button
              onClick={() => {
                logout();
                setMobileMenuOpen(false);
              }}
 className="flex items-center space-x-2 w-full text-left px-4 py-2 text-secondary-500 hover:text-secondary-700 text-sm font-medium"
            >
 <LogOut className="h-4 w-4" />
              <span>{t("auth:logout")}</span>
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
